---
title: Prywatność
updated: 2026-10-02
---

## 1. Administrator Danych

Draughts Game („my") jest administratorem danych osobowych zbieranych za pośrednictwem tej platformy. Kontakt: [privacy@draughtsgame.com](mailto:privacy@draughtsgame.com)

## 2. Jakie Dane Zbieramy

### 2.1 Dane Konta

- **Nazwa użytkownika** - wybrana przez Ciebie, widoczna publicznie
- **Adres e-mail** - szyfrowany w spoczynku algorytmem AES-256-GCM, używany do identyfikacji konta, niewidoczny publicznie
- **Hasło** - przechowywane jako hash bcrypt (współczynnik kosztu 12), nigdy w postaci jawnej
- **Potwierdzenie wieku** - odnotowujemy, że przy rejestracji potwierdziłeś ukończenie 16 lat
- **Status weryfikacji e-mail** - czy potwierdziłeś swój adres e-mail, oraz krótkotrwałe tokeny weryfikacji i resetowania hasła
- **Personalizacja profilu (opcjonalnie)** - awatar i kraj, wybrane przez Ciebie, widoczne publicznie

### 2.2 Dane Gry

- Ruchy, wyniki i znaczniki czasu partii
- Rankingi i statystyki graczy
- Udział w turniejach i wyniki
- Próby rozwiązywania zadań, ranking zadań i serie rozwiązań (streaki)
- Twoja biblioteka do nauki: notatki do pozycji (dowolny tekst, który sam piszesz), foldery, zapisane partie i pozycje zapisane w edytorze — prywatne, widoczne tylko dla Ciebie

### 2.3 Dane Techniczne

- Adres IP (dla bezpieczeństwa i wykrywania oszustw)
- Ciąg user-agent przeglądarki
- Tokeny sesji

### 2.4 Zgłoszenia do Pomocy Technicznej

Jeśli skontaktujesz się z nami przez formularz pomocy, zbieramy Twój adres e-mail, opcjonalne imię oraz temat i treść wiadomości, aby móc obsłużyć Twoje zgłoszenie i na nie odpowiedzieć.

## 3. Podstawa Prawna Przetwarzania

Przetwarzamy Twoje dane osobowe na podstawie:

- **Wykonania umowy** (art. 6 ust. 1 lit. b RODO) - w celu świadczenia usługi gry, na którą się zarejestrowałeś, w tym e-maili transakcyjnych (weryfikacja konta, resetowanie hasła) i odpowiedzi pomocy technicznej.
- **Prawnie uzasadnionych interesów** (art. 6 ust. 1 lit. f RODO) - dla bezpieczeństwa platformy, wykrywania oszustw, zbiorczych statystyk gry (jakie warianty są grane, jak kończą się partie) i ulepszania usługi.
- **Zgoda** (art. 6 ust. 1 lit. a RODO) - na pomiar użycia przez Umami i śledzenie błędów przez Sentry. Żadne z nich nie uruchomi się, dopóki nie zaakceptujesz w banerze.

## 4. Jak Wykorzystujemy Twoje Dane

- Dostarczanie i obsługa platformy gry
- Uwierzytelnianie konta i utrzymywanie sesji
- Obliczanie i wyświetlanie rankingów graczy
- Dobieranie przeciwników i organizacja turniejów
- Wykrywanie i zapobieganie oszustwom i nadużyciom
- Wysyłanie e-maili transakcyjnych (weryfikacja konta, resetowanie hasła)
- Obsługa zgłoszeń do pomocy technicznej i odpowiadanie na nie
- Ulepszanie usługi dzięki zagregowanym, anonimowym statystykom
- Analizowanie danych z rozgrywek (np. rozegranych wariantów, wyników) w formie zagregowanej i zanonimizowanej w celu zrozumienia użytkowania i ulepszania platformy

## 5. Pliki Cookie i Usługi Zewnętrzne

Używamy niezbędnych plików cookie do uwierzytelniania i zapisywania Twoich preferencji. Korzystamy z następujących usług:

- **Umami** (statystyki) - hostowane samodzielnie na naszej własnej infrastrukturze w UE. Nie używa plików cookie i uruchamia się tylko wtedy, gdy zaakceptujesz statystyki w banerze. Wizyty są rozpoznawane po pseudonimowym odcisku, wyliczanym z Twojego adresu IP i przeglądarki i odnawianym codziennie; liczby są wykorzystywane wyłącznie zbiorczo i nie śledzimy Cię w innych witrynach.
- **Sentry** (śledzenie błędów) - włączane wyłącznie za Twoją zgodą.
- **Resend** (dostarczanie e-maili) - dostarcza nasze e-maile transakcyjne (weryfikacja konta, resetowanie hasła) oraz powiadomienia pomocy technicznej.
- **DigitalOcean** (hosting) - centrum danych w UE (Frankfurt).

Nie sprzedajemy Twoich danych ani nie używamy trackerów reklamowych.

## 6. Przechowywanie Danych

- **Dane konta** - przechowywane tak długo, jak Twoje konto jest aktywne.
- **Konta gości** - usuwane automatycznie po 30 dniach nieaktywności.
- **Konta niezweryfikowane** - jeśli założysz konto, ale nigdy nie potwierdzisz swojego adresu e-mail, konto zostanie automatycznie usunięte po 30 dniach nieaktywności.
- **Tokeny odświeżania** - wygasają po 7 dniach (90 dniach w przypadku kont gości, żebyś mógł odnaleźć swoje partie bez hasła), czyszczone automatycznie co godzinę. Adres IP i dane przeglądarki powiązane z sesją są usuwane po 7 dniach, nawet jeśli sama sesja trwa dłużej.
- **Tokeny weryfikacji e-mail** - wygasają po 24 godzinach.
- **Tokeny resetowania hasła** - wygasają po 1 godzinie.
- **Zgłoszenia do pomocy technicznej** - przechowywane tak długo, jak to konieczne do obsługi zgłoszenia.
- **Zgłoszenia nadużyć** - gdy gracz zgłosi kogoś za nadużycia na czacie, czat tej partii (do 100 wiadomości, od obu graczy) jest przechowywany do moderacji i usuwany automatycznie po 90 dniach. W pozostałych przypadkach czat nie jest nigdy przechowywany.
- **Dane gry** - przechowywane bezterminowo jako część publicznego archiwum partii.
- **Biblioteka do nauki** - notatki do pozycji, foldery, zapisane partie i zapisane pozycje są przechowywane do momentu ich usunięcia przez Ciebie, a w każdym razie usuwane wraz z kontem.
- **Dane błędów Sentry** - usuwane automatycznie po 90 dniach.
- **Usunięte konta** - dane osobowe są usuwane natychmiast po usunięciu konta. Zapisy partii są anonimizowane (usuwane jest odniesienie do gracza).

## 7. Twoje Prawa (RODO)

Zgodnie z Ogólnym Rozporządzeniem o Ochronie Danych (RODO) masz prawo do:

- **Dostępu** (art. 15) - pobierz kopię swoich danych osobowych w ustawieniach profilu („Eksportuj moje dane").
- **Sprostowania** (art. 16) - zmień hasło w ustawieniach profilu. W sprawie innych poprawek skontaktuj się z nami.
- **Usunięcia** (art. 17) - usuń konto w ustawieniach profilu („Usuń konto"). Operacja jest natychmiastowa i nieodwracalna.
- **Przenoszenia danych** (art. 20) - wyeksportuj swoje dane w formacie JSON czytelnym maszynowo z ustawień profilu.
- **Ograniczenia** (art. 18) - zażądaj ograniczenia przetwarzania, kontaktując się z nami.
- **Sprzeciwu** (art. 21) - odrzucenie statystyk w banerze cookie wyłącza **zarówno** pomiar użycia Umami, **jak i** śledzenie błędów Sentry. W każdej chwili możesz to zmienić przełącznikiem w ustawieniach profilu.

Aby skorzystać z któregokolwiek z tych praw, użyj narzędzi samoobsługowych w ustawieniach profilu lub skontaktuj się z nami pod adresem [privacy@draughtsgame.com](mailto:privacy@draughtsgame.com). Odpowiemy w ciągu 30 dni.

## 8. Bezpieczeństwo Danych

Stosujemy odpowiednie środki techniczne i organizacyjne w celu ochrony Twoich danych osobowych, w tym szyfrowanie danych wrażliwych w spoczynku i podczas przesyłania, bezpieczne hashowanie haseł oraz ograniczanie liczby żądań (rate limiting) na punktach końcowych uwierzytelniania.

## 9. Przekazywanie Danych za Granicę

Twoje dane są przechowywane i przetwarzane głównie na terenie Europejskiego Obszaru Gospodarczego (EOG), w centrum danych DigitalOcean we Frankfurcie. Dane błędów Sentry mogą być przekazywane do USA na podstawie decyzji o adekwatności EU-US Data Privacy Framework (lipiec 2023). Możesz wyłączyć Sentry w ustawieniach profilu. E-maile transakcyjne są dostarczane przez Resend (USA); to przekazywanie jest objęte umową powierzenia przetwarzania danych ze standardowymi klauzulami umownymi.

## 10. Prywatność Dzieci

Usługa nie jest przeznaczona dla dzieci poniżej 16 roku życia (art. 8 RODO). Wymagamy potwierdzenia wieku przy rejestracji. Świadomie nie zbieramy danych osobowych dzieci poniżej 16 lat. Jeśli dowiemy się, że zebraliśmy dane dziecka poniżej 16 roku życia, niezwłocznie je usuniemy.

## 11. Zmiany w Niniejszej Polityce

Możemy od czasu do czasu aktualizować niniejszą Politykę Prywatności. O istotnych zmianach powiadomimy zarejestrowanych użytkowników komunikatem na platformie. Data „Ostatnia aktualizacja" u góry wskazuje najnowszą wersję.

## 12. Organ Nadzorczy

Masz prawo złożyć skargę do właściwego organu nadzorczego ds. ochrony danych, jeśli uważasz, że Twoje prawa do ochrony danych zostały naruszone.

## 13. Kontakt

W przypadku pytań dotyczących niniejszej Polityki Prywatności:

- E-mail: [privacy@draughtsgame.com](mailto:privacy@draughtsgame.com)
